import React from "react";
import { Form } from "antd";
import Scrollbar from "../../tools/common/Scrollbar";
import { OBJECT_COMPONENT_DEFINITION } from "./ObjectComponentDefinition";

const TYPE_ALIASES = {
  rect: "shape",
  ellipse: "shape",
  triangle: "shape",
  polygon: "shape",
};

const getPanelType = (item) => {
  if (!item) return null;
  return TYPE_ALIASES[item.superType] || item.superType;
};

const ObjectPropertiesPanel = ({
  canvasRef,
  selectedItem,
  form,
  onChange,
  ...rest
}) => {
  if (!selectedItem) return null;

  const panelKey = getPanelType(selectedItem);
  const Component = OBJECT_COMPONENT_DEFINITION[panelKey];

  if (!Component) {
    console.warn("No component for:", selectedItem.superType);
    return null;
  }

  const { getFieldDecorator, getFieldValue } = form;

  return (
    <Scrollbar>
      <Form layout="horizontal" colon={false} key={selectedItem?.id}>
        <ul className="rde-ul">
          <li className="rde-ul__li">
            <Component
              form={getFieldDecorator}
              getFieldValue={getFieldValue}
              selectedItem={selectedItem}
              canvasRef={canvasRef}
              {...rest}
            />
          </li>
        </ul>
      </Form>
    </Scrollbar>
  );
};

export default Form.create({
  onValuesChange: (props, changedValues, allValues) => {
    const { onChange, selectedItem } = props;

    const key = Object.keys(changedValues)[0];
    const value = changedValues[key];
    onChange(selectedItem, key, value, allValues);
  },
})(ObjectPropertiesPanel);